import { useMemo } from "react";

import { typedQueryClient } from "hooks";
import { PendingChecklistsQueryKeys } from "modules/PendingChecklistsDashboard/queryKeys";

import type { WebSocketMessageListener } from "components";
import type { InterventionKeywordPendingChecklist } from "models";

export const useInterventionPendingChecklistsListeners = () => {
  const listeners = useMemo(() => {
    const interventionChecklistsListeners: WebSocketMessageListener<InterventionKeywordPendingChecklist>[] = [
      {
        model: "InterventionKeywordPendingChecklist",
        action: "upsert",
        callback: ({ data: interventionPendingChecklist }) => {
          const interventionPendingChecklists = typedQueryClient.getQueryData(PendingChecklistsQueryKeys.interventionPendingChecklists);

          const interventionPendingChecklistIdx =
            interventionPendingChecklists?.findIndex(
              p =>
                p.checklist_id === interventionPendingChecklist.checklist_id &&
                p.keyword === interventionPendingChecklist.keyword &&
                p.vin_prefix === interventionPendingChecklist.vin_prefix
            ) ?? -1;

          const updateInterventionPendingChecklists = [...(interventionPendingChecklists || [])];

          if (interventionPendingChecklistIdx < 0) updateInterventionPendingChecklists.push(interventionPendingChecklist);
          else
            updateInterventionPendingChecklists[interventionPendingChecklistIdx] = {
              ...updateInterventionPendingChecklists[interventionPendingChecklistIdx],
              ...interventionPendingChecklist
            };

          typedQueryClient.setQueryData(PendingChecklistsQueryKeys.interventionPendingChecklists, updateInterventionPendingChecklists);
        }
      },
      {
        model: "InterventionKeywordPendingChecklist",
        action: "delete",
        callback: ({ data: interventionPendingChecklist }) => {
          const interventionPendingChecklists = typedQueryClient.getQueryData(PendingChecklistsQueryKeys.interventionPendingChecklists);
          if (!interventionPendingChecklists || !interventionPendingChecklists.length) return;

          const interventionPendingChecklistIdx = interventionPendingChecklists.findIndex(
            p =>
              p.checklist_id === interventionPendingChecklist.checklist_id &&
              p.keyword === interventionPendingChecklist.keyword &&
              p.vin_prefix === interventionPendingChecklist.vin_prefix
          );
          if (interventionPendingChecklistIdx < 0) return;

          typedQueryClient.setQueryData(
            PendingChecklistsQueryKeys.interventionPendingChecklists,
            interventionPendingChecklists.toSpliced(interventionPendingChecklistIdx, 1)
          );
        }
      }
    ];

    return [...interventionChecklistsListeners];
  }, []);

  return listeners;
};
